export default __webpack_public_path__ + "static/media/facebook.2fe2aa2c.svg";